import { render } from "./video.vue?vue&type=template&id=d843174c"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=d843174c&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__